module.exports = __webpack_public_path__ + "static/media/proj8_img2.632cc4cb.jpg";